import { TrackingToolsFromTable } from "components/Tables/TrackingToolsFromTable/TrackingToolsFromTable.tsx";
import { TenantPage } from "components/UI/TenantPage/TenantPage.tsx";
import { PermissionEnum } from "types/enums.ts";
import { createTenantFileRoute } from "utils/createTenantFileRoute.ts";
import { getToolTrackingHeaderItems } from "utils/tenantHeaderItems.ts";

export const Route = createTenantFileRoute(
    "/_authenticated/$tenantSlug/_layout/tool/_layout/tracking/_layout/s2s-postback/"
)({
    component: TrackingToolsFromPage,
    staticData: {
        permissions: [PermissionEnum.ToolTrackingIncoming],
        showInSideMenu: false,
        label: "pages.tool.tracking.from.title",
    },
    loader: ({ context: { t } }) => {
        return { breadcrumb: t("pages.tool.tracking.from.title") };
    },
});

function TrackingToolsFromPage() {
    return (
        <TenantPage headerNavigationItems={getToolTrackingHeaderItems}>
            <TrackingToolsFromTable />
        </TenantPage>
    );
}
